const thumbnails = [
  {
    title: "Women's boots",
    path: "women",
    icon: "./images/thumbnails/2007-_-_boots_dt_Thumbnails-14.jpg",
  },
  {
    title: "Men's jackets",
    path: "men jacket",
    icon: "./images/thumbnails/2007-__jackets_dt_Thumbnails-13.jpg",
  },
  {
    title: "Women's shoes",
    path: "Women",
    icon: "./images/thumbnails/0109-Mobi-Triple-banner-Heels.jpg",
  },
  {
    title: "Men's Sneakers",
    path: "men",
    icon: "./images/thumbnails/2007-_-_sneakers_dt_Thumbnails-16.jpg",
  },
  {
    title: "T-Shirts",
    path: "t-shirt",
    icon: "./images/thumbnails/0109-Mobi-Triple-banner-Mens-T-shirts.jpg",
  },
  {
    title: "Sandals",
    path: "sandals",
    icon: "./images/thumbnails/0109-Mobi-Triple-banner-Womens-Sandals.jpg",
  },
];

export default thumbnails;
